import { render, staticRenderFns } from "./image-container.vue?vue&type=template&id=b6c93fd2&"
import script from "./image-container.vue?vue&type=script&lang=js&"
export * from "./image-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports